module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('title-user', [_vm._v("Ativar TAG")]), _vm._v(" "), _c('div', {
    staticClass: "margin-t30"
  }, [(_vm.vehicle) ? _c('div', {
    staticClass: "row row-fix content-box vehicles"
  }, [_c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('div', {
    staticClass: "plate-box"
  }, [_c('p', {
    staticClass: "cell-plate info-car"
  }, [_c('span', {
    attrs: {
      "data-v-214ba40a": ""
    }
  }, [_vm._v(_vm._s(_vm.plate))])])]), _vm._v(" "), _c('div', {
    staticClass: "tag-box"
  }, [_c('p', {
    staticClass: "no-margin bold"
  }, [_vm._v("TAG N°")]), _vm._v(" "), _c('p', {
    staticClass: "no-margin"
  }, [_vm._v(_vm._s(_vm.serial))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "vehicle-box"
  }, [_c('p', {
    staticClass: "no-margin bold"
  }, [_vm._v(_vm._s(_vm.vehicle.model.brand.name))]), _vm._v(" "), _c('p', {
    staticClass: "no-margin bold"
  }, [_vm._v(_vm._s(_vm._f("firstWord")(_vm.vehicle.model.name)))]), _vm._v(" "), _c('p', {
    staticClass: "no-margin three-dots"
  }, [_vm._v(_vm._s(_vm._f("fromSecWord")(_vm.vehicle.model.name)))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [(_vm.msg) ? _c('div', {
    staticClass: "margin-b20 alert",
    class: _vm.errorClass
  }, [_c('p', [_vm._v(_vm._s(_vm.msg))])]) : _vm._e()])]) : _c('div', [(_vm.msg) ? _c('div', {
    staticClass: "margin-b20 alert",
    class: _vm.errorClass
  }, [_c('p', [_vm._v(_vm._s(_vm.msg))])]) : _vm._e()])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg btn-xxl",
    attrs: {
      "onclick": "Native.openScanner()"
    }
  }, [_vm._v("\n        Escanear outro veículo\n      ")]), _vm._v(" "), _c('i', {
    staticClass: "icon-marquee align-icon"
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('router-link', {
    staticClass: "btn btn-back margin-t20",
    attrs: {
      "to": {
        name: 'plans'
      },
      "tag": "button"
    }
  }, [_c('i', {
    staticClass: "icon-circle-left align-icon-left"
  }), _vm._v("\n        Voltar\n      ")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-65914c75!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/result-activate-tag.vue
// module id = 2154
// module chunks = 1